import React from "react";
import { useLang } from "@/context/LanguageContext";

export const LanguageToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="language-toggle"
      className="inline-flex items-center rounded-full border border-[#20261E]/10 bg-white/70 p-1 backdrop-blur-xl"
    >
      {["gr", "en"].map((code) => (
        <button
          key={code}
          data-testid={`lang-${code}`}
          onClick={() => setLang(code)}
          className={`rounded-full px-4 py-1.5 text-sm transition-all duration-200 ${
            lang === code
              ? "bg-[#24483A] font-semibold text-white"
              : "font-medium text-[#5B6053] hover:text-[#20261E]"
          }`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
